<template>
    <section class="padding-vertical-content" key="paso2" id="paso2">
        <div class="container">
            <b-row>
                <b-col cols="12">
                    <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</h2>
                    <h3 class="subtitle h3 light mb-3 ">{{ $t('nuevo_abono.varios_asientos') }}</h3>
                    <button @click="volver" class="h6 button small-button mr-0" :disabled="disabled"> <i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                    <button v-if="recuperarSoloZonaAnexas" @click="$emit('continuarSinPlazaParking')" class="h6 button small-button mr-0 ml-2" :disabled="disabled">{{ $t('nuevo_abono.no_parking') }}</button>
                </b-col>
                <b-col md="8" sm="12" class="lightgray-content text-center p-0 prueba">
                    <ContentOrLoading style="min-height: 400px; padding: 0.3em; background-color: #ededed;">
                        <LeafletComponent
                            v-if="! loading"
                            :plazasSeleccionadas="butacasSeleccionadas"
                            :svgRendered="svgRendered"
                            :originalColor="originalColor"
                            @isPanning="(e) => isPanning = e"
                        />
                    </ContentOrLoading>
                </b-col>
                <b-col md="4" sm="12">
                    <div class="d-flex flex-column justify-content-between" style="height: 100%;">
                        <div class="overflow-auto tusEntradas">
                            <div 
                                v-for="(butaca, index) in butacasSeleccionadas"
                                class="lightgray-content p-2 mb-2"
                                :key="index"
                            >
                                <div class="text-bold mb-2 d-flex justify-content-between">
                                    <div class="oswald d-flex">
                                        {{ (num = index + 1) }}. <span v-html="getButacaName(butaca)"></span>
                                    </div>
                                    <span
                                        role="button"
                                        class="oswald"
                                        :disabled="disabled"
                                        @click="clickButaca(butaca.id)"
                                    >
                                        <i class="fas fa-times mr-2"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <b-button 
                            v-if="butacasSeleccionadas.length > 0" 
                            class="btn btn-block mb-0"
                            :disabled="disabled"
                            @click="continuarCompra"
                        >
                            {{ $t('partido.continuar') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </div>
    </section>
</template>

<script>
    import { Popover } from 'bootstrap';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            abonado: {
                type: Object,
                required: false
            },
            recuperarSoloZonaAnexas: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: true,
                butacasSeleccionadas: [],
                butacas: [],
                svgRendered: null,
                originalColor: '#0CBA31',
                seleccionadaColor: '#8CA9D9',
                datos_comporadores: [],
                renovacion: false
            }
        },
        created() {
            if (this.$route.query.n_abonado_antiguo) {
                this.renovacion = true;
            }

            this.getButacas();
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            
                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
        },
        methods: {
            getSvg() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    lista_abonado_id: this.lista_abonados.id,
                    recinto_id: this.recinto.id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.regiones.anexas.svg'), params).then(({ data: { svg } }) => {
                    this.renderLeafletSvg(svg);
                }).catch(e => {
                    console.error('Error al obtener el svg general.');
                });
            },
            getButacas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: this.renovacion
                    },
                    lista_id: this.lista_abonados.id,
                    recinto_id: this.recinto.id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.regiones.anexas.butacas'), params).then(res => {
                    this.butacas = res.data.data;

                    if(this.$route.query.plaza_id) {
                        let butaca = this.butacas.find(({id}) => parseInt(id) === parseInt(this.$route.query.plaza_id));

                        if(butaca) {
                            this.clickButaca(butaca.id);
                        }

                        if (this.abonado && this.abonado.plaza) {
                            if (this.abonado.tipos_abonos && this.abonado.tipos_abonos.every(tipo_abono => tipo_abono.descuentos)) {
                                const plazaCopia = {
                                    ...this.abonado.plaza,
                                    precios: this.abonado.tipos_abonos
                                };
                                this.butacas.push(plazaCopia);                            
                            }
                        }
                    }

                    this.getSvg();
                });
            },
            volver() {
                if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.$emit('volver');
                }
            },
            renderLeafletSvg(svg) {
                const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                    if (butaca) {
                        const title = this.getButacaName(butaca);

                        if (this.abonado && this.abonado.plaza && this.abonado.plaza.id === butaca.id) {
                            const content = 'Tu anterior butaca';
                            this.drawPopover(circle, content, title);

                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            butaca.originalColor = this.originalColor;
                            const butacaFinded = this.butacas.find(butacaItem => butacaItem.id === butaca.id);
                            if (butacaFinded) {
                                butacaFinded.precios = this.abonado.tipos_abonos;
                            }
                            circle.setAttribute('fill', this.seleccionadaColor);
                            circle.setAttribute('seleccionado', 'true');
                            this.clickButaca(butaca.id);
                            this.continuarCompra();
                        }

                        if (butaca.libre && butaca.precios.length > 0) {
                            const content = `Disponible`;
                            this.drawPopover(circle, content, title);

                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s'
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.disabled) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(butaca.id);
                                    }
                                }, 150);
                            });            
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
                this.loading = false;
            },
            drawPopover(circle, content, title = null) {
                if (this.load_panzoom) {
                    const popoverOptions = {
                        html: true,
                        title: title,
                        content: content,
                        trigger: 'hover'
                    }

                    return new Popover(circle, popoverOptions);
                }            
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            clickButaca(butacaId) {
                if (!this.disabled) {
                    let nuevaButacaSeleccionada = null;
                    let reemplazarSeleccion = false;

                    const butacaSeleccionada = this.butacas.find(butaca => butaca.id === butacaId);

                    if (butacaSeleccionada) {
                        const index = this.butacasSeleccionadas.findIndex(selectedButaca => selectedButaca.id === butacaId);
            
                        const svgElement = this.svgRendered;
                        const svgButaca = svgElement ? svgElement.querySelector(`#butaca-${butacaSeleccionada.svg_id}`) : null;
            
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                            
                            if (svgButaca) {
                                svgButaca.setAttribute('fill', this.originalColor);
                                svgButaca.setAttribute('seleccionado', 'false');
                            }
                        } else {
                            this.butacasSeleccionadas.push(butacaSeleccionada);
                            nuevaButacaSeleccionada = butacaSeleccionada;
                            reemplazarSeleccion = true;
                            
                            if (svgButaca) {
                                svgButaca.setAttribute('fill', this.seleccionadaColor);
                                svgButaca.setAttribute('seleccionado', 'true');
                            }
                        }
            
                        if (reemplazarSeleccion && this.abonado && this.abonado.id) {
                            this.butacasSeleccionadas = [nuevaButacaSeleccionada];
                            
                            if (svgElement) {
                                const allButacas = svgElement.querySelectorAll('[id^="butaca"]');
                                allButacas.forEach(circle => {
                                    circle.setAttribute('fill', this.originalColor);
                                    circle.setAttribute('seleccionado', 'false');
                                });
                                
                                if (svgButaca) {
                                    svgButaca.setAttribute('fill', this.seleccionadaColor);
                                    svgButaca.setAttribute('seleccionado', 'true');
                                }
                            }
                        }
                    }
                }
            },
            continuarCompra() {
                let datos_compradores = [];

                this.butacasSeleccionadas.forEach(butaca => {
                    let descuentos = [];
                
                    butaca.precios.forEach(tipo_abono => {
                        descuentos = descuentos.concat(tipo_abono.descuentos);
                    });

                    datos_compradores.push({
                        'apellidos': this.abonado ? this.abonado.surnames : '',
                        'dni': this.abonado ? this.abonado.dni : '',
                        'es_nuevo': true,
                        'nombre': this.abonado ? this.abonado.name : '',
                        'precio': null,
                        'precios': descuentos,
                        'tipos_abonos': butaca.precios,
                        'telefono': this.abonado ? this.abonado.telefono : '',
                        'url_imprimir': '',
                        'plaza': butaca,
                        'n_abonado_antiguo': this.abonado ? this.abonado.n_abonado_antiguo : '',
                        'email': this.abonado ? this.abonado.email : '',
                        'domicilio': this.abonado ? this.abonado.domicilio : '',
                        'cp': this.abonado ? this.abonado.cp : ''
                    });
                });

                this.$emit('asientosSeleccionados', datos_compradores, datos_compradores);
            }
        },
        components: {
            LeafletComponent
        }
    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .prueba {
            margin-left: 1em;
            margin-bottom: 1em;
            margin-right: 1em;
        }
    }
</style>